import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from '../services/auth.service';

/**
 * ProtectedRoute Component
 * 
 * Wrapper component that checks authentication before rendering admin routes.
 * Redirects to login page if not authenticated.
 * 
 * Requirements:
 * - US3: Admin route protection
 */

export const ProtectedRoute: React.FC = () => {
  if (!isAuthenticated()) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};
